import { type JSX } from "react";

import { Menu as BaseMenu } from "@base-ui/react/menu";

export function MenuTrigger({
  ...props
}: React.ComponentProps<typeof BaseMenu.Trigger>): JSX.Element {
  return <BaseMenu.Trigger data-slot="menu-trigger" {...props} />;
}
